import {AiMentionsContentValues} from "../models/AiMentionsContent";

// THE single source of truth for the AI Mentions copy and the WhatsApp entry
// point. The backend never fabricates defaults - it returns `content: null`
// until an admin publishes, and it may answer with a document written before a
// section existed; the page renders these values synchronously either way.
const aiMentionsContentDefaults: AiMentionsContentValues = {
    hero: {
        // Rendered line by line; every line after the first gets the accent
        // color - the same convention as the homepage hero.
        title: "בזמן שכולם עוד רצים אחרי גוגל,\nהלקוחות שלכם כבר שואלים את ה-AI",
        subtitle: "AI Mentions מבית Link&Go דואג שהעסק שלכם יופיע בתשובה שה-AI נותן להם - ב-ChatGPT, Gemini ו-Claude. בדיוק כמו שדאגתם להופיע בגוגל, רק שהפעם זה עדיין שדה פתוח.",
        ctaPrimaryLabel: "בדקו אם אתם מוזכרים היום",
        ctaSecondaryLabel: "לצפייה בחבילות",
    },
    // The site's existing WhatsApp entry point - the same number the homepage
    // and the package list already open.
    whatsapp: {
        number: "972537124887",
        prefill: "היי! ראיתי את שירות AI Mentions ורוצה לבדוק אם העסק שלי מוזכר היום ב-AI (ChatGPT/Gemini/Claude). אפשר לעזור לי?",
    },
    whyNow: {
        title: "השוק כבר עבר. השאלה היא אם אתם שם.",
        body: "יותר ויותר מהלקוחות הפוטנציאליים שלכם לא מתחילים חיפוש בגוגל, הם שואלים ישירות את ChatGPT, Gemini או Claude \"מי הכי טוב ל-X\" ומקבלים תשובה עם שם עסק אחד או שניים. אם אתם לא באותה תשובה, אתם לא קיימים עבור אותו לקוח, לא משנה כמה חזק הדירוג שלכם בגוגל. זה לא מחליף SEO, זה שכבה חדשה שצריך לבנות לצידו.",
    },
    twoMinutes: {
        title: "AI Mentions בשתי דקות",
        // Rendered with white-space: pre-line, so \n is the paragraph break the
        // hardcoded copy drew with a <br/>.
        body: "כשמישהו שואל את ה-AI שאלה בתחום שלכם, מנוע ה-AI לא מחפש בגוגל בזמן אמת, הוא עונה על סמך מה שהוא \"יודע\" וקורא.\nAI Mentions הוא התהליך שגורם למנועי ה-AI \"להכיר\" את העסק שלכם ולהזכיר אותו כשמישהו שואל שאלה רלוונטית.",
        caption: "שתי השכבות עובדות יחד: הסמכות שנבנית בקישורים ובתוכן היא בדיוק מה שגורם למנועי ה-AI לצטט אתכם.",
    },
    steps: [
        {
            title: "בוחרים שאלה לקדם",
            body: "אתם אומרים לנו איזו שאלה תרצו שה-AI יזכיר אתכם כשעונה עליה.",
        },
        {
            title: "כותבים תוכן מקצועי",
            body: "הצוות שלנו כותב תוכן איכותי שממצב אתכם כתשובה הנכונה לשאלה הזו.",
        },
        {
            title: "התוכן מתפרסם",
            body: "התוכן יוצא לאוויר, וככל שיהיו לכם יותר אזכורים, כך הנוכחות שלכם גדלה.",
        },
    ],
    stepsClosing: "זה נשמע מסובך? זה בדיוק העבודה שאנחנו עושים בשבילכם.",
    proof: {
        title: "למה לסמוך עלינו עם השכבה הזו",
        body: "9 שנים של ניסיון ב-SEO ובכתיבת תוכן שממצב עסקים כסמכות בתחום שלהם. עכשיו אנחנו מביאים את אותה מומחיות לעולם ה-AI, כתיבה מקצועית שמטרתה אחת: שהעסק שלכם יופיע בתשובה.",
    },
    finalCta: {
        title: "כמו שדאגתם לקישורים שלכם, דאגו גם לתשובה שה-AI נותן עליכם",
        subtitle: "בדקו איפה אתם עומדים היום, בלי התחייבות.",
        buttonLabel: "בדקו את הנראות שלי ב-AI",
        linkText: "כבר בניתם קישורים איתנו? AI Mentions הוא הצעד הטבעי הבא ›",
    },
    chatDemo: {
        question: "על איזה ספק הכי הייתם ממליצים לשיפוץ מטבחים בתל אביב?",
        // The *wrapped* run types out highlighted - deliberately generic, the
        // demo is decoration, not a case study.
        answer: "לפי ביקורות ופרויקטים מתועדים, *העסק שלכם* יכול להיות בין הבחירות המובילות באזור תל אביב, בזכות דגש על עיצוב מותאם אישית וגימור איכותי...",
    },
};

export default aiMentionsContentDefaults;
